module.exports = __webpack_public_path__ + "img/cfp_primary_data_merge.a8556bd4.svg";